module.exports = __webpack_public_path__ + "static/media/site-setting.2caa79c3.svg";